<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <!--Chart content-->
  <div class="row common-page-contentwrap">
    <div class="col-md-12">
      <div [hidden]="pgLoad">
        <div class="adjust loader-container">
          <div class="loader2"></div>
        </div>
      </div>
      <!-- breadcrumb -->
      <div [hidden]="!pgLoad" class="row">
        <div class="col-md-12">
          <div class="page-breadcrumb">
            <ul class="page-breadcrumb__trail">
                <li><a>Metrics</a></li>
                <li><a>Ponds</a></li>
              </ul>
            <div class="page-breadcrumb__icons">
              <a routerLink="/home/dashboard"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>        
            </div>
          </div>
        </div>
      </div>
      <!-- breadcrumb End -->
      <div class="block" [hidden]="!pgLoad">
        <div class="screen_heading_div">
          <span>Pond</span>
        </div>
        <div class="metrics-cards_container row">
          <!-- Pods grid -->
          <div [hidden]="!pgLoad" class="row">
            <div [hidden]="!pgLoad" class="col-xs-12">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 fcr_chart">
                <div class="x_chart_panel   ">
                  <div class="x_chart_title">
                    <h2><strong> {{charttitle}}</strong></h2>
                    <ul class="nav navbar-right chart_panel_toolbox">
                      <li><img src="../../../../../../assets/img/metrics_icons/piechart.svg" width="20px"
                               (click)="activepondgraphselection('doughnut')"
                               [ngClass]="activepondType == 'doughnut'?('colorblue'):('colorblack')" height="17px"/>
                      </li>
                      <li><img src="../../../../../../assets/img/metrics_icons/reports.svg" width="20px"
                               (click)="activepondgraphselection('bar')"
                               [ngClass]="activepondType == 'bar'?('colorblue'):('colorblack')" height="17px"/>
                      <li><img aria-hidden="true" data-toggle="modal" data-target="#activeModal" width="20px"
                               height="17px"
                               (click)="getAllActivePondLocation()"
                               src="../../../../../../assets/img/metrics_icons/location.svg"/></li>
                    </ul>
                    <div class="clearfix"></div>
                  </div>
                  <div class="x_content">
                    <div id="canvasarea">
                      <canvas id="activePondChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>
              <!--list-->
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <div class="panel panel-default" *ngIf="activeandsizeList && activeandsizeList.length > 0">
                  <div class="col-lg-12">
                    <div class="metrics-search_button_container">
                      <div class="search-div">
                        <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
                        <input type="text" (keyup)="searchActiveBusiness()" [(ngModel)]="activesearch"
                               name="search" autocomplete="off" placeholder="search..">
                      </div>
                    </div>
                  </div>
                  <div class="panel-body table-responsive tablescroll">
                    <table class="table table-striped table-hover">
                      <thead>
                      <tr>
                        <th>Business Name</th>
                        <th>Pond Name</th>
                        <th>Section Name</th>
                        <th>Ponds by period of Activity</th>
                      </tr>
                      </thead>
                      <tbody>
                      <div [hidden]="responseLoad">
                        <div class="adjust">
                          <div class="loaderstyle loader2"></div>
                        </div>
                      </div>
                      <tr class="searchfunactive" *ngFor="let list of activeandsizeList">
                        <td>
                          {{list && list.FarmSiteBusinessEntity[0] && list.FarmSiteBusinessEntity[0].businessID && list.FarmSiteBusinessEntity[0].businessID.businessName}}
                        </td>
                        <td>{{list && list.name}}</td>
                        <td>
                          {{(list && list.PondSection && list.PondSection.section_name == null) ? '--' : (list && list.PondSection && list.PondSection.section_name)}}
                        </td>
                        <td>{{list && list.doc}}</td>
                      </tr>
                      </tbody>
                    </table>
                    <p class="panel panel-default x_chart_panel nodata"
                       *ngIf="activeandsizeList && activeandsizeList.length == 0"> No data
                      found</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div [hidden]="!pgLoad" class="row">
            <div [hidden]="!pgLoad" class="col-xs-12">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 fcr_chart">
                <div class="x_chart_panel   ">
                  <div class="x_chart_title">
                    <h2><strong> {{inActivecharttitle}}</strong>&nbsp;&nbsp;</h2>
                    <ul class="nav navbar-right chart_panel_toolbox">
                      <li><img src="../../../../../../assets/img/metrics_icons/piechart.svg" width="20px"
                               (click)="inactivepondgraphselection('doughnut')"
                               [ngClass]="inactivepondType == 'doughnut'?('colorblue'):('colorblack')" height="17px"/>
                      </li>
                      <li><img src="../../../../../../assets/img/metrics_icons/reports.svg" width="20px"
                               (click)="inactivepondgraphselection('bar')"
                               [ngClass]="inactivepondType == 'bar'?('colorblue'):('colorblack')" height="17px"/>
                      <li><img aria-hidden="true" data-toggle="modal" data-target="#inActiveModal" width="20px"
                               height="17px"
                               (click)="getAllInActivePondLocation()"
                               src="../../../../../../assets/img/metrics_icons/location.svg"/></li>
                    </ul>
                    <div class="clearfix"></div>
                  </div>
                  <div class="x_content">
                    <div id="inactivePondcanvasarea">
                      <canvas id="inactivePondChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>
              <!--list-->
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <div class="panel panel-default" *ngIf="inactiveandsizeList && inactiveandsizeList.length>0">
                  <div class="col-lg-12">
                    <div class="metrics-search_button_container">
                      <div class="search-div">
                        <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
                        <input type="text" (keyup)="searchInActiveBusiness()" [(ngModel)]="inactivesearch"
                               name="search" autocomplete="off" placeholder="search..">
                      </div>
                    </div>
                  </div>
                  <div class="panel-body table-responsive tablescroll">
                    <table class="table table-striped table-hover">
                      <thead>
                      <tr>
                        <th>Business Name</th>
                        <th>Pond Name</th>
                        <th>Section Name</th>
                        <th>Ponds by period of Inactivity</th>
                      </tr>
                      </thead>
                      <tbody>
                      <div [hidden]="responseLoad">
                        <div class="adjust">
                          <div class="loaderstyle loader2"></div>
                        </div>
                      </div>
                      <tr class="searchfuninactive" *ngFor="let list of inactiveandsizeList">
                        <td>
                          {{list && list.FarmSiteBusinessEntity[0] && list.FarmSiteBusinessEntity[0].businessID && list.FarmSiteBusinessEntity[0].businessID.businessName}}
                        </td>
                        <td>{{list && list.name}}</td>
                        <td>
                          {{(list && list.PondSection && list.PondSection.section_name == null) ? '--' : (list && list.PondSection && list.PondSection.section_name)}}
                        </td>
                        <td>{{list && list.doc}}</td>
                      </tr>
                      </tbody>
                    </table>
                    <p class="panel panel-default x_chart_panel nodata"
                       *ngIf="inactiveandsizeList && inactiveandsizeList.length == 0"> No data
                      found</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div [hidden]="!pgLoad" class="row">
            <div [hidden]="!pgLoad" class="col-xs-12">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 fcr_chart">
                <div class="x_chart_panel   ">
                  <div class="x_chart_title">
                    <h2><strong> {{pondSizecharttitle}}</strong></h2>
                    <ul class="nav navbar-right chart_panel_toolbox">
                      <li><img src="../../../../../../assets/img/metrics_icons/piechart.svg" width="20px"
                               (click)="pondsizegraphselection('doughnut')"
                               [ngClass]="pondsizeType == 'doughnut'?('colorblue'):('colorblack')" height="17px"/>
                      </li>
                      <li><img src="../../../../../../assets/img/metrics_icons/reports.svg" width="20px"
                               (click)="pondsizegraphselection('bar')"
                               [ngClass]="pondsizeType == 'bar'?('colorblue'):('colorblack')" height="17px"/>
                      <li><img aria-hidden="true" data-toggle="modal" data-target="#pondSizeModal" width="20px"
                               height="17px"
                               (click)="getAllPondSizeLocation()"
                               src="../../../../../../assets/img/metrics_icons/location.svg"/></li>
                    </ul>
                    <div class="clearfix"></div>
                  </div>
                  <div class="x_content">
                    <div id="pondsizecanvasarea">
                      <canvas id="pondSizeChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <!--list-->
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <div class="panel panel-default" *ngIf="activeandsizeList && activeandsizeList.length > 0">
                  <div class="col-lg-12">
                    <div class="metrics-search_button_container">
                      <div class="search-div">
                        <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
                        <input type="text" (keyup)="searchSizeBusiness()" [(ngModel)]="sizesearch"
                               name="search" autocomplete="off" placeholder="search..">
                      </div>
                    </div>
                  </div>
                  <div class="panel-body table-responsive tablescroll">
                    <table class="table table-striped table-hover">
                      <thead>
                      <tr>
                        <th>Business Name</th>
                        <th>Pond Name</th>
                        <th>Section Name</th>
                        <th>Pond Size(Acrs)</th>
                      </tr>
                      </thead>
                      <tbody>
                      <div [hidden]="responseLoad">
                        <div class="adjust">
                          <div class="loaderstyle loader2"></div>
                        </div>
                      </div>
                      <tr class="searchfunsize" *ngFor="let list of activeandsizeList">
                        <td>
                          {{list && list.FarmSiteBusinessEntity[0] && list.FarmSiteBusinessEntity[0].businessID && list.FarmSiteBusinessEntity[0].businessID.businessName}}
                        </td>
                        <td>{{list && list.name}}</td>
                        <td>
                          {{(list && list.PondSection && list.PondSection.section_name == null) ? '--' : (list && list.PondSection && list.PondSection.section_name)}}
                        </td>
                        <td>{{(list && list.pond_size == null) ? '--' : (list && list.pond_size.toFixed(2))}}</td>
                      </tr>
                      </tbody>
                    </table>
                    <p class="panel panel-default x_chart_panel nodata"
                       *ngIf="activeandsizeList && activeandsizeList.length == 0"> No data found</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Ponds grid -->
      </div>
      <!-- Active doc Location details-->
      <div class="modal fade" id="activeModal" role="dialog"
           *ngIf="activePondLocations && activePondLocations.length>0">
        <div class="modal-dialog active_location">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close close_btn" data-dismiss="modal"  title="Close Popup">&times;</button>
              <h4 class="modal-title location_heading">Active pond Location View</h4>
            </div>
            <div class="modal-body location_data  totalfarmermodelscrollbar" id="style-4">
              <div *ngFor="let location of activePondLocations" class="row">
                <div class="col-xs-12 location_state">
                  <p>{{location.state}}</p>
                </div>
                <div *ngFor="let village of location.data" class="doc_details col-lg-12">
                  <div class="col-xs-9 doc_villagename">
                    <span>{{village.village}}</span>
                  </div>
                  <div class="col-xs-3 doc_pondcount">
                    <p class="pull-right">{{village.count}} Pond(s)</p>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading"><span>&#8804;</span> 30days</h3>
                    <h3 class="pull-right doc_count">{{village.doc0to30}}</h3>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">31 - 60days</h3>
                    <h3 class="pull-right doc_count">{{village.doc31to60}}</h3>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">61 - 90days</h3>
                    <h3 class="pull-right doc_count">{{village.doc61to90}}</h3>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">91 - 120days</h3>
                    <h3 class="pull-right doc_count">{{village.doc91to120}}</h3>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">> 120days</h3>
                    <h3 class="pull-right doc_count">{{village.greaterthan120}}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer ambrolive-popup-close">
              <button class="center-block submitbtn" data-dismiss="modal"
                      type="submit"><img src="assets/images/New_Icons/close.svg">Close
              </button>
            </div>
          </div>

        </div>
      </div>
      <!-- Active doc Location details end -->
      <!-- InActive doc Location details-->
      <div class="modal fade" id="inActiveModal" role="dialog"
           *ngIf="inActivePondLocations && inActivePondLocations.length>0">
        <div class="modal-dialog active_location">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close close_btn" data-dismiss="modal"  title="Close Popup">&times;</button>
              <h4 class="modal-title location_heading">inActive pond Location View</h4>
            </div>
            <div class="modal-body location_data  totalfarmermodelscrollbar" id="style-4">
              <div *ngFor="let location of inActivePondLocations" class="row">
                <div class="col-xs-12 location_state">
                  <p>{{location.state}}</p>
                </div>
                <div *ngFor="let village of location.data" class="doc_details col-lg-12">
                  <div class="col-xs-9 doc_villagename">
                    <span>{{village.village}}</span>
                  </div>
                  <div class="col-xs-3 doc_pondcount">
                    <p class="pull-right">{{village.count}} Pond(s)</p>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading"><span>&#8804;</span> 30days</h3>
                    <h3 class="pull-right doc_count">{{village.doc0to30}}</h3>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">31 - 60days</h3>
                    <h3 class="pull-right doc_count">{{village.doc31to60}}</h3>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">61 - 90days</h3>
                    <h3 class="pull-right doc_count">{{village.doc61to90}}</h3>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">91 - 120days</h3>
                    <h3 class="pull-right doc_count">{{village.doc91to120}}</h3>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">> 120days</h3>
                    <h3 class="pull-right doc_count">{{village.greaterthan120}}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer ambrolive-popup-close">
              <button class="center-block submitbtn" data-dismiss="modal"
                      type="submit"><img src="assets/images/New_Icons/close.svg">Close
              </button>
            </div>
          </div>

        </div>
      </div>
      <!-- InActive doc Location details end -->
      <!-- Pond size Location details-->
      <div class="modal fade" id="pondSizeModal" role="dialog" *ngIf="pondSizeLocations && pondSizeLocations.length>0">
        <div class="modal-dialog active_location">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close close_btn" data-dismiss="modal"  title="Close Popup">&times;</button>
              <h4 class="modal-title location_heading">Pond size Location View</h4>
            </div>
            <div class="modal-body location_data  totalfarmermodelscrollbar" id="style-4">
              <div *ngFor="let location of pondSizeLocations" class="row">
                <div class="col-xs-12 location_state">
                  <p>{{location.state}}</p>
                </div>
                <div *ngFor="let village of location.data" class="doc_details col-lg-12">
                  <div class="col-xs-6 doc_villagename">
                    <span>{{village.village}}</span>
                  </div>
                  <div class="col-xs-6 doc_pondcount">
                    <p class="pull-right">{{village.count}} Pond(s)</p>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">0.1 - 0.3 ha</h3>
                    <h3 class="pull-right doc_count">{{village.pointone_pointthree}}</h3>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">0.4 - 0.5 ha</h3>
                    <h3 class="pull-right doc_count">{{village.pointfour_pointfive}}</h3>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">0.6 - 0.8 ha</h3>
                    <h3 class="pull-right doc_count">{{village.pointsix_pointeight}}</h3>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">0.9 - 1.0 ha</h3>
                    <h3 class="pull-right doc_count">{{village.pointnine_one}}</h3>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">>1.0 ha</h3>
                    <h3 class="pull-right doc_count">{{village.greaterthanone}}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer ambrolive-popup-close">
              <button class="center-block submitbtn" data-dismiss="modal"
                      type="submit"><img src="assets/images/New_Icons/close.svg">Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Pond size Location details end -->
    </div>
  </div>
</div>
<!--  </div>
</div>-->
